import { Injectable } from "@angular/core";
import { Preferencias } from "../models/preferencias";
import { Preferences } from '@capacitor/preferences';

@Injectable({
    providedIn: 'root'
})
export class PreferenciasService {
    private readonly chave = 'preferencias';

    async obter(): Promise<Preferencias> {
        const { value } = await Preferences.get({
            key: this.chave
        });

        return value
        ? JSON.parse(value) as Preferencias
        : {
            localizacaoAtual: null,
            historicoLocalizacao: []
        };
    }

    async salvar(preferencias: Preferencias): Promise<void> {
        await Preferences.set({
            key: this.chave,
            value: JSON.stringify(preferencias)
        });
    }

    async adicionarHistoricoLocalizacao(
    descricao: string,
    latitude: number,
    longitude: number
    ): Promise<void> {
        const preferencias = await this.obter();

        preferencias.historicoLocalizacao =
            preferencias.historicoLocalizacao.filter(
            local =>
                local.latitude !== latitude ||
                local.longitude !== longitude
            );

        preferencias.historicoLocalizacao.unshift({
            descricao,
            latitude,
            longitude
        });

        preferencias.historicoLocalizacao =
            preferencias.historicoLocalizacao.slice(0, 3);

        preferencias.localizacaoAtual = preferencias.historicoLocalizacao[0];

        await this.salvar(preferencias);
    }
}
